import './components/finn-topbar-hydration-fix.js';
import './components/browser-warning.js';
import './components/onboarding-modal/onboarding-modal-entrypoint.js';
import './components/onboarding-modal/onboarding-modal.js';
import './components/notification-bubble.js';
import './components/topbar-data-service.js';
import './topbar-tracking.js';
import '@schibsted-nmp/messaging-icon';
import '@warp-ds/icons/elements/bell-24';
import '@warp-ds/icons/elements/bell-filled-24';
import '@warp-ds/icons/elements/circle-plus-24';
import '@warp-ds/icons/elements/circle-plus-filled-24';
import '@warp-ds/icons/elements/circle-user-24';
import '@warp-ds/icons/elements/building-24';
import '@warp-ds/icons/elements/circle-user-filled-24';
import '@warp-ds/icons/elements/house-24';
import '@warp-ds/icons/elements/messages-24';
import '@warp-ds/icons/elements/messages-filled-24';
import '@warp-ds/elements/components/attention';
//import './add-warp-global-styles-if-necessary.js';
